/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInProfileViewStepOverrideTaskNoteDoc } from './linkedInProfileViewStepOverrideTaskNoteDoc';

export interface LinkedInProfileViewStepOverride {
  type: 'linkedin_profile_view';
  task_note_doc?: LinkedInProfileViewStepOverrideTaskNoteDoc;
}
